export const orange = {
    light: '#FF9C22',
    main: '#DF7B00',
    dark: '#884B00',
    contrastText: "#FFF"
}

export const green = {
    light: '#3CAE83',
    main: '#048e5a',
    dark: '#005937',
    contrastText: "#FFF"
}